import { httpV2 } from '@/bundles/Http/factory/httpFactory';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';
import ChatSessionService from '@/bundles/AiAgent/services/ChatSessionService';
import { IChatSession } from '@/bundles/AiAgent/types';
import ChatSession from '@/bundles/AiAgent/models/ChatSession';
import { RecordMapper } from '@/bundles/App/models/RecordMapper';

function chatSessionServiceFactory () {
  return new ChatSessionService(
    httpV2,
    new ErrorMapper(),
    new RecordMapper<IChatSession>(ChatSession),
  );
}

export const chatSessionService = chatSessionServiceFactory();
